/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface WeightLossCancelSubDto { 
    /**
     * The program identifier.
     */
    programId: string;
    /**
     * The program status.
     */
    programStatus: WeightLossCancelSubDto.ProgramStatusEnum;
    /**
     * The time when the program ended.
     */
    programEndedAt: string;
    /**
     * The subscription identifier.
     */
    subscriptionId: string;
    /**
     * The subscription status.
     */
    subscriptionStatus: WeightLossCancelSubDto.SubscriptionStatusEnum;
    /**
     * The free-text explanation to why the subscription has the current status.
     */
    subscriptionStatusReason: string;
}
export namespace WeightLossCancelSubDto {
    export type ProgramStatusEnum = 'pending' | 'active' | 'ended';
    export const ProgramStatusEnum = {
        Pending: 'pending' as ProgramStatusEnum,
        Active: 'active' as ProgramStatusEnum,
        Ended: 'ended' as ProgramStatusEnum
    };
    export type SubscriptionStatusEnum = 'PENDING' | 'ACTIVE' | 'CLOSED';
    export const SubscriptionStatusEnum = {
        Pending: 'PENDING' as SubscriptionStatusEnum,
        Active: 'ACTIVE' as SubscriptionStatusEnum,
        Closed: 'CLOSED' as SubscriptionStatusEnum
    };
}


